import { useCallback } from 'react'
import useOpenModal from './hooks/useOpenModal'
//
import { Wrapper, Area, IconBrand, ButtonFilter, IconFilter, IconSearch, IconPlace } from './Styled'

import brandingIcon from '@theme/icon/branding.png'
import filterIcon from '@theme/icon/filter.svg'

interface HeaderProps {
  searchTypes?: any
}

/** 元件 Header - CMS View 最上方的 Header */
export default function Header({ searchTypes }: HeaderProps) {
  const { openSearchVideoViaViaSpecificModal, openFilterModal } = useOpenModal()

  const onOpenSearch = useCallback(
    (searchTypes: any) => {
      openSearchVideoViaViaSpecificModal(searchTypes)
    },
    [openSearchVideoViaViaSpecificModal]
  )

  const onOpenFilterModal = useCallback(() => {
    openFilterModal()
  }, [openFilterModal])

  return (
    <Wrapper>
      <IconPlace></IconPlace>
      <IconBrand src={brandingIcon} />

      <Area onClick={() => onOpenSearch(searchTypes)}>
        输入关键字搜寻
        <IconSearch />
      </Area>

      <ButtonFilter onClick={onOpenFilterModal}>
        <IconFilter src={filterIcon} />
        筛选
      </ButtonFilter>
    </Wrapper>
  )
}
